import React, { useEffect, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import Button from "@material-ui/core/Button";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Paper from "@material-ui/core/Paper";
import Draggable from "react-draggable";
import Close from "@material-ui/icons/Close";
import { useTranslation } from "react-i18next";

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper
        style={{ minHeight: 200, wordBreak: "break-word", width: 200 }}
        {...props}
      />
    </Draggable>
  );
}

function DisplayMessage(props) {
  const [open, setOpen] = useState(true);

  const { t } = useTranslation();
  useEffect(() => {
    if (props.message.length > 0) {
      setOpen(true);
    }
  }, [props.random]);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
  
    setOpen(false);
  };
  function handleChange(event){
    if (event.code === "Escape") {
      setOpen(false);
    }
  }
  return (
    <div onKeyDown={(e)=>handleChange(e)}>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          <p id="about-title">
            {t("CONTENT.LIBRARY.DISPLAY-MESSAGE.ACTION.MESSAGE")}
            <Button data-test="cancelautom-button" onClick={handleClose}>
              <Close />
            </Button>
          </p>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <p style={{ color: "black" }}>{props.message}</p>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </div>
  );
}
export default DisplayMessage;

